import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { PortalSetup } from './portal-setup';
import './App.scss';

class App extends Component {

  handleRouteChange(params) {
    const { location } = params;
    const { state } = location || {};
    const { focusElement } = state || {};
    const element = document.getElementById(focusElement ? focusElement : "view");
    element && element.focus();

    const intercomApplicationId = process.env.INTERCOM_APPLICATION_ID;
    const { Intercom } = window;
    const useIntercom = (intercomApplicationId && Intercom);
    if (useIntercom) {
      Intercom('update');
    }
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    this.handleRouteChange(this.props);
  }

  componentDidUpdate(prevProps) {
    const { location : prevLocation } = prevProps;
    const { location : currentLocation } = this.props;
    if(currentLocation.pathname !== prevLocation.pathname) {
      this.handleRouteChange(this.props);
    }
  }
  render() {

    return (
      <div>
        <div tabIndex="-1" id="view" className="no-focus">
          <Switch>
            <Route exact path="/" component={PortalSetup}/>
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// src/App.js